import { Action, createReducer, on } from "@ngrx/store";
import { IBannerState } from "./banner.state";
import { setIsBannerDownAction } from "./banner.actions";

export const initialBannerState: IBannerState = {
    isBannerDown: false
}

const bannerReducer = createReducer(
    initialBannerState,

    on(setIsBannerDownAction,
        (state, action): IBannerState => ({
            ...state,
            isBannerDown: action.stateFlag
        })
    )
);

export function bannerReducers(state: IBannerState, action: Action) {
    return bannerReducer(state, action);
}